export default __webpack_public_path__ + "static/media/WCS.1df26bee.png";